interface State {
    isEditing: boolean,
    notes: Array<Object>
}

const data = {
    isEditing: false,
    editingId: null,
    notes: [
        
    ]
}

export type {State}
export default data;